'use client';

import { AuthProvider } from '@/lib/auth';
import { ToastProvider } from '@/components/Toast';
import { ConfirmProvider } from '@/components/ConfirmDialog';
import { BrandingProvider } from '@/lib/branding-context';
import { ServiceWorkerRegister } from '@/components/ServiceWorkerRegister';

export function Providers({ children }: Readonly<{ children: React.ReactNode }>) {
  return (
    <BrandingProvider>
      <AuthProvider>
        <ToastProvider>
          <ConfirmProvider>
            <ServiceWorkerRegister />
            {children}
          </ConfirmProvider>
        </ToastProvider>
      </AuthProvider>
    </BrandingProvider>
  );
}
